<app-login *ngIf="appStatus === 'logging'"></app-login>
<app-sign-up *ngIf="appStatus === 'registering'"></app-sign-up>
<app-main-page *ngIf="appStatus === 'blogging'"></app-main-page>
